var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2002 24C12.6389 24 13.8778 23.131 14.4214 21.8906H7.979C8.52261 23.131 9.76157 24 11.2002 24Z",
    fill: "url(#paint0_linear_4109_4186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4659 11.6185V10.0781C18.4659 6.80522 16.2904 4.0312 13.3096 3.12516V2.10938C13.3096 0.946266 12.3634 0 11.2003 0C10.0371 0 9.09088 0.946266 9.09088 2.10938V3.12516C6.11009 4.0312 3.93463 6.80517 3.93463 10.0781V11.6185C3.93463 14.4935 2.83878 17.2195 0.848984 19.2946C0.653984 19.4979 0.599188 19.798 0.709719 20.0571C0.82025 20.3162 1.07478 20.4844 1.3565 20.4844H21.044C21.3257 20.4844 21.5802 20.3162 21.6907 20.0571C21.8013 19.798 21.7465 19.4979 21.5515 19.2946C19.5617 17.2195 18.4659 14.4934 18.4659 11.6185ZM11.9034 2.84663C11.672 2.82431 11.4374 2.8125 11.2003 2.8125C10.9631 2.8125 10.7285 2.82431 10.4971 2.84663V2.10938C10.4971 1.72167 10.8125 1.40625 11.2003 1.40625C11.588 1.40625 11.9034 1.72167 11.9034 2.10938V2.84663Z",
    fill: "url(#paint1_linear_4109_4186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3407 10.0783C20.3407 10.4666 20.6555 10.7814 21.0438 10.7814C21.4321 10.7814 21.7469 10.4666 21.7469 10.0783C21.7469 7.2611 20.6499 4.61253 18.6578 2.62048C18.3833 2.34593 17.9381 2.34588 17.6635 2.62048C17.3889 2.89507 17.3889 3.34024 17.6635 3.61484C19.3899 5.34129 20.3407 7.63671 20.3407 10.0783Z",
    fill: "url(#paint2_linear_4109_4186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.35645 10.7814C1.74476 10.7814 2.05957 10.4666 2.05957 10.0783C2.05957 7.63673 3.01038 5.34131 4.73679 3.61486C5.01138 3.34026 5.01138 2.89509 4.73679 2.6205C4.46224 2.3459 4.01702 2.3459 3.74243 2.6205C1.75038 4.61254 0.65332 7.26107 0.65332 10.0783C0.65332 10.4666 0.968133 10.7814 1.35645 10.7814Z",
    fill: "url(#paint3_linear_4109_4186)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4109_4186",
    x1: 11.2002,
    y1: 21.8906,
    x2: 11.2002,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4109_4186",
    x1: 11.2002,
    y1: -6.10482e-7,
    x2: 11.2002,
    y2: 20.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4109_4186",
    x1: 19.6022,
    y1: 2.41455,
    x2: 19.6022,
    y2: 10.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4109_4186",
    x1: 2.79803,
    y1: 2.41455,
    x2: 2.79803,
    y2: 10.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon_notification_active.6f60a35798fcc7b73f37713d7d17d7b7.svg";
export { ForwardRef as ReactComponent };